import moment from 'moment'
import {calculateDate} from '../../../../utils'
import {ListInputFieldForm} from '../../../../utils/TypeCommon'
import {ContractModel} from '../../healthInsurance/model/ContractModel'
import {InsurancePlanModel} from '../../healthInsurance/model/InsurancePlanModel'

interface AutoOfferFeeModel {
  id: string | null
  vehicleOwner: string | null
  code: string | null
  name: string | null
  address: string | null
  startDate: string | null
  licensePlate: string | null
  chassisNumber: string | null
  engineNumber: string | null
  expireDate: string | null
  manufacturingYear: string | null
  seat: string | null
  payload: string | null
  carCompany: string | null
  carBrand: string | null
  driverNumber: string | null
  capacity: string | null
  vehicleGroupsCode: string | null
  purposeOfUseType: string | null
  price: string | null
  amountCar: string | null
  packageCode: string | null
  sumFee: string | null
  validateForm: boolean | null
  fieldInput: ListInputFieldForm
  contractPackageBenefitChecked: any
  contractPackageExtensionChecked: any
  _sellingContractCarPackageBenefitDtos: any
  _sellingContractCarPackageExtensionDtos: any
}

interface AutoListCarModel {
  id: string | null
  ownerCode: string | null
  ownerVersion: string | null
  oldContractCode: string | null
  certType: string | null
  certNumber: string | null
  vehicleOwner: string | null
  address: string | null
  licensePlate: string | null
  chassisNumber: string | null
  engineNumber: string | null
  startDate: string | null
  expireDate: string | null
  objectInsuredType: string | null
  manufacturingYear: string | null
  seat: string | null
  payload: string | null
  carCompany: string | null
  carBrand: string | null
  driverNumber: string | null
  capacity: string | null
  vehicleGroupsCode: string | null
  engineType: string | null
  fuelType: string | null
  purposeOfUseType: string | null
  price: string | null
  code: string | null
  sumFee: string | null
  sumTax: string | null
  validateForm: boolean | null
  listCar: any
  payeeName: string | null
  payeeNameIdentificationNumber: string | null
  payeePhone: string | null
  payeeEmail: string | null
  contractPackageBenefitChecked: any
  contractPackageExtensionChecked: any
  payeesRelationsShip: string | null
  packageChoosed: string | null
  listObjectSelected: any
  fieldInput: ListInputFieldForm
  nationality: string | null
}

export interface AutoInitialStateModel {
  tabName?: string
  sellingContractId?: string
  customerCode?: string
  customerVersion?: number
  groupDomainCode?: string
  contractType?: number
  contractKind?: number
  originalContract?: string
  packageExtension?: any
  packageInsurance?: any
  form: {
    activeForm: number
    formStatus: number | null
    formData: {
      formAutoInsurancePlan?: InsurancePlanModel
      formAutoOfferFee?: AutoOfferFeeModel
      formAutoListUser?: AutoListCarModel
      formAutoContract?: ContractModel
    }
  }
}

export interface ListAutoInitialStateModel extends Array<AutoInitialStateModel> {}

export const autoInitialState: ListAutoInitialStateModel = [
  {
    tabName: undefined,
    sellingContractId: undefined,
    customerCode: undefined,
    customerVersion: undefined,
    groupDomainCode: undefined,
    contractType: undefined,
    contractKind: undefined,
    originalContract: undefined,
    packageExtension: undefined,
    packageInsurance: undefined,
    form: {
      activeForm: 1,
      formStatus: null,
      formData: {
        formAutoInsurancePlan: {
          businessProgramCode: null,
          productCode: 'AUTO_V',
          exploitingType: null,
          exploitingCode: null,
          typeOfIntroduction: null,
          introductionCode: null,
          curencyMoney: null,
          curencyFee: null,
          exchangeRate: '1',
          exchangeRateNote: null,
          business: null,
          businessName: null,
          currencyFeeChange: null,
          validateForm: null,
          tpa: null,
          tpaType: null,
          tpaFee: null,
          adjacentContractNumberLoss: null,
          adjacentContractNumber: null,
          paymentTimeType: null,
          paymentTimeDay: null,
          calculationType: '0',
          nationality: null,
        },
        formAutoOfferFee: {
          id: null,
          vehicleOwner: null,
          code: null,
          name: null,
          address: null,
          startDate: moment().format('YYYY/MM/DD HH:mm'),
          licensePlate: null,
          chassisNumber: null,
          engineNumber: null,
          expireDate: calculateDate(moment().format('YYYY/MM/DD HH:mm'), true),
          manufacturingYear: moment().year().toString(),
          seat: '5',
          payload: '0',
          carCompany: null,
          carBrand: null,
          driverNumber: '0',
          capacity: '0',
          vehicleGroupsCode: null,
          purposeOfUseType: '2',
          price: null,
          amountCar: '1',
          packageCode: null,
          sumFee: null,
          validateForm: null,
          fieldInput: [],
          contractPackageBenefitChecked: null,
          contractPackageExtensionChecked: null,
          _sellingContractCarPackageBenefitDtos: null,
          _sellingContractCarPackageExtensionDtos: null,
        },
        formAutoListUser: {
          id: null,
          certType: null,
          certNumber: null,
          ownerCode: null,
          ownerVersion: null,
          oldContractCode: null,
          vehicleOwner: null,
          address: null,
          licensePlate: null,
          chassisNumber: null,
          engineNumber: null,
          startDate: moment().format('YYYY/MM/DD HH:mm'),
          expireDate: calculateDate(moment().format('YYYY/MM/DD HH:mm'), true),
          objectInsuredType: null,
          manufacturingYear: null,
          seat: null,
          payload: null,
          carCompany: null,
          carBrand: null,
          driverNumber: null,
          capacity: null,
          vehicleGroupsCode: null,
          engineType: '0',
          fuelType: '0',
          purposeOfUseType: null,
          price: null,
          code: null,
          sumFee: null,
          sumTax: null,
          validateForm: null,
          listCar: null,
          payeeName: null,
          payeeNameIdentificationNumber: null,
          payeePhone: null,
          payeeEmail: null,
          contractPackageBenefitChecked: null,
          contractPackageExtensionChecked: null,
          payeesRelationsShip: null,
          packageChoosed: null,
          listObjectSelected: null,
          fieldInput: [],
          nationality: null,
        },
        formAutoContract: {
          agency: null,
          contractType: null,
          contractNumber: null,
          originalCode: null,
          created: null,
          purchaseDate: null,
          startDate: null,
          expireDate: null,
          manager: null,
          totalPerson: null,
          sumFee: null,
          partyARepresentative: null,
          partyAPosition: null,
          partyBRepresentative: null,
          partyBPosition: null,
          partyBPhone: null,
          partyAPhone: null,
          partyAPowerOfAttorney: null,
          partyBPowerOfAttorney: null,
          partyBFax: null,
          proxy: null,
          bankCode: null,
          sumTax: null,
          taxType: null,
          bankNumber: null,
          _sellingContractPaymentScheduleDtos: null,
          _sellingContractExtraDataDtos: null,
          _listContractPackages: null,
          lossRatio: null,
          validateForm: null,
          exploName: null,
          exploManager: null,
          exploitingType: null,
          tsIncharge: null,
          pmIncharge: null,
          paymentTimeType: null,
          commission: '0',
          adminFee: '0',
          vatAdminFee: null,
          endorStartDate: null,
          endorExpireDate: null,
          endorNote: null,
          userReceiveMail: null,
          customerConfirmDate: null,
          dateMoF: null,
        },
      },
    },
  },
]
